import React, { Component } from 'react'
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { openEventFormModal } from 'reducers/logbook/reducer'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import messages from './translate'
import EventCreateForm from './EventCreateForm'

class EventFormModal extends Component {
  onClose = () => {
    this.props.openEventFormModal({
      isOpen: false,
      type: null,
    })
  }

  render() {
    const {
      intl: { formatMessage },
      isOpenEventFormModal,
    } = this.props

    return (
      <Dialog
        fullScreen={ifWindowWidthLessThan(599)}
        open={isOpenEventFormModal}
        onClose={this.onClose}
        className="logbook-modal">
        <AppBar position="absolute">
          <Toolbar className="event-modal-toolbar">
            <Typography variant="h6">
              {formatMessage(messages.createEvent)}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={this.onClose}
              aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <EventCreateForm />
      </Dialog>
    )
  }
}

export default connect(
  state => ({
    isOpenEventFormModal: state.getIn(['logbook', 'isOpenEventFormModal']),
  }),
  {
    openEventFormModal,
  },
)(injectIntl(EventFormModal))
